type AdditionalConfigurationItem = {
  sys?: { id?: string | null } | null;
  type?: string | null;
} | null;

type AdditionalConfigurationCollection = {
  items?: Array<AdditionalConfigurationItem> | null;
} | null;

/**
 * Resolve a technical component entry id from Global Page Settings
 * `additionalConfigurationCollection` by Contentful `type`.
 */
export const findAdditionalConfigurationIdByType = (
  collection: AdditionalConfigurationCollection | undefined,
  type: string
): string | undefined => {
  const items = collection?.items ?? [];

  for (const item of items) {
    if (item?.type === type && item.sys?.id) {
      return item.sys.id;
    }
  }

  return undefined;
};
